<template>
  <div class="tost-container" v-if="visible">{{content}}</div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
  .tost-container {
    z-index: 9999999;
    opacity: 0.7;
    background: #000000;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    padding: 20px 90px;
    text-align: center;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
</style>
